class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const ajaxForm = document.getElementById('AjaxCartForm');
		if (!ajaxForm || typeof ajaxForm.querySelectorAll !== 'function') {
			this.innerHTML = '';
			return;
		}

		const cartItems = ajaxForm.querySelectorAll('[data-js-cart-item]');
		const cartProductIds = new Set(
			Array.from(cartItems)
				.map((el) => String(el.dataset.productId || ''))
				.filter(Boolean)
		);

		if (cartItems.length === 0) {
			this.innerHTML = '';
			return;
		}

		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
			.then((response) => response.text())
			.then((text) => {
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const perf = doc.querySelector('[data-js-cart-recommendations-performed]');

				if (!perf || perf.querySelectorAll('[data-js-product-item]').length === 0) {
					this.innerHTML = '';
					return;
				}

				/** Hide upsell strip when cart already contains any product shown here (avoid clutter / overshadow). */
				const recProductEls = perf.querySelectorAll('[data-js-product-item][data-rec-product-id]');
				for (const el of recProductEls) {
					const pid = String(el.dataset.recProductId || '');
					if (pid && cartProductIds.has(pid)) {
						this.innerHTML = '';
						return;
					}
				}

				this.innerHTML = perf.innerHTML;
			})
			.catch(() => {
				this.innerHTML = '';
			});
	}
}
customElements.define('cart-recommendations', CartRecommendations);
